// import { uk, enUS } from 'date-fns/locale';

export let DATEFORMAT = 'dd MMM yyyy HH:mm';
export let SOMEERROR = 'Some error';
export let PASSWORDISREQUiRED = 'Password is required';
export let PASSWORDMUSTBE = 'Password must be at least 8 characters long, contain at least one letter and one number and one special character.';

// status
export let UPCOMING = 'upcoming';
export let ONGOING = 'ongoing';
export let COMPLETED = 'completed';
export let CANCELED = 'cancelled';

// var
export let BOOKER = 'booker';
export let TYPEIMAGE = 'image';
export let TYPEVIDEO = 'video';
export let CLOSEACCOUNT = 'close account';

// color 
export let DARCKCOLOR = '#1E1E1F';
export let DARCKCOLOR2 = '#212529';
export let DARCKCOLOR3 = '#1e1e1fb3';
export let DARCKBACKGROUND = '#1E1E1F';
export let DARCKBORDER = '#1E1E1F';
export let DARCKOPACITYCOLOR6 = 'rgba(33, 37, 41, 0.6)';
export let DARCKOPACITYCOLOR8 = 'rgba(33, 37, 41, 0.8)';
export let DARCKOPACITYBACKGROUND6 = 'rgba(33, 37, 41, 0.6)';
export let DARCKOPACITYBACKGROUND8 = 'rgba(33, 37, 41, 0.8)';
export let GRAYCOLOR = 'rgba(107, 114, 128, 1)';

// Mixpanel
export let PAGEVIEW = 'Page Viewed';
export let BOOKINGGUIDE = 'Booking Guide';
export let BOOKINGFAILED = 'Booking Failed';
export let CANCELEDGUIDE = 'Canceled Guide';
export let APPERROR = 'App Error';
export let FETCHERROR = 'Fetch Error';
export let GOOGLESIGNINERROR = 'Google Sign-in failed';
export let GOOGLESIGNIN = 'Google Sign-in';
export let SIGNIN = 'Sign-in';
export let SIGNINERROR = 'Sign-in Error';
export let SIGNUP = 'Sign-Up';
export let SIGNUPERROR = 'Sign-Up Error';
export let RESETPASSWORD = 'Reset Password';
export let RESETPASSWORDWITHOLD = 'Reset password with old';
export let FORGOTPASSWORD = 'Forgot Password';
export let DELETEACCOUNT = 'Deleting Account';
export let LOGOUT = 'Logout';
export let DELETEACCOUNTERROR = 'Deleting Account Error';
export let CONNECTSTREAM = 'Connect to stream';

// settings
export let NOTIFICATIONS = 'notifications';
export let LOCATION = 'location';
export let ALLOWDATA = 'data';
export let TRUEVALUE = 'true';


export const reactQuilltoolbar = [
  [{ header: [1, 2, 3, 4, 5, 6, false] }],
  ['bold', 'italic', 'underline', 'strike'],
  [{ list: 'ordered' }, { list: 'bullet' }],
  ['blockquote', 'code-block'],
  ['link'],
  [{ script: 'sub' }, { script: 'super' }], 
  [{ indent: '-1' }, { indent: '+1' }],
  [{ direction: 'rtl' }], 
  [{ size: ['small', false, 'large', 'huge'] }],
  [{ align: [] }], 
  ['clean'], 
];

export const countryPhoneLengths = {
  cn: 11, // Китай
  in: 10, // Індія
  us: 11, // США
  id: 10, // Індонезія
  pk: 10, // Пакистан
  br: 11, // Бразилія
  ng: 13, // Нігерія
  bd: 10, // Бангладеш
  mx: 10, // Мексика
  jp: 10, // Японія
  et: 10, // Ефіопія
  ph: 10, // Філіппіни
  eg: 10, // Єгипет
  vn: 11, // В'єтнам
  cd: 9, // Демократична Республіка Конго
  tr: 11, // Туреччина
  ir: 10, // Іран
  th: 9, // Таїланд
  fr: 9, // Франція
  gb: 10, // Велика Британія
  it: 10, // Італія
  tz: 9, // Танзанія
  za: 9, // ПАР
  mm: 9, // М'янма
  ke: 10, // Кенія
  kr: 11, // Південна Корея
  co: 10, // Колумбія
  es: 9, // Іспанія
  ug: 9, // Уганда
  ua: 12, // Україна
  de: 9, // Німеччина
  at: 9, // Австрія
  ch: 9, // Чеська
  pl: 9, // Польща
  ro: 9, // Румунія
};

export const languageMap = {
  en: 'English',
  es: 'Spanish',
  fr: 'French',
  de: 'German',
  ru: 'Russian',
  uk: 'Ukrainian',
  zh: 'Chinese',
  ja: 'Japanese',
  it: 'Italian',
  pt: 'Portuguese',
  ar: 'Arabic',
  bn: 'Bengali',
  hi: 'Hindi',
  ko: 'Korean',
  vi: 'Vietnamese',
  tr: 'Turkish',
  pl: 'Polish',
  nl: 'Dutch',
  sv: 'Swedish',
  no: 'Norwegian',
  da: 'Danish',
  fi: 'Finnish',
  cs: 'Czech',
  ro: 'Romanian',
  el: 'Greek',
  hu: 'Hungarian',
  th: 'Thai',
  he: 'Hebrew',
  id: 'Indonesian',
  ms: 'Malay',
  ta: 'Tamil',
  te: 'Telugu',
  ur: 'Urdu',
  fa: 'Persian',
  sw: 'Swahili',
  kk: 'Kazakh',
  bg: 'Bulgarian',
  sk: 'Slovak',
  hr: 'Croatian',
  sr: 'Serbian',
  sl: 'Slovenian',
  lv: 'Latvian',
  lt: 'Lithuanian',
  et: 'Estonian',
  is: 'Icelandic',
  ga: 'Irish',
  mt: 'Maltese',
};
